import React from "react";
import {
  ImaginationWrapper,
  ImaginationContainer,
  ImaginationContent,
} from "./style";

const Imagination = () => {
  return (
    <ImaginationWrapper>
      <ImaginationContainer>
        <ImaginationContent>
          <span data-aos="fade-down">Stellar Edit</span>
          <h1 data-aos="fade-down">Expand your imagination</h1>
        </ImaginationContent>
        <img src="/assets/imagination.png" alt="Expand your imagination" data-aos="fade-down" />
      </ImaginationContainer>
    </ImaginationWrapper>
  );
};

export default Imagination;
